import { Component } from "@angular/core";
@Component({
  selector: "gh-example-tooltip-component",
  templateUrl: "./example-tooltip.component.html",
  styleUrls: [],
})
export class ExampleTooltipComponent {
  public visible = false;

  public change(isVisible: boolean): void {
    this.visible = isVisible;
  }
}
